// client/src/routes/app/contracts/$contractId/schedule.tsx — SCR-CON-003 tab „Program chirii" ·
// CON-005 phase 1 (the seam), phase 2 (the periods).
//
// This is where activation LANDS (05 CON-005 criterion 1: "activation triggers schedule
// generation and lands on the detail page showing generated periods"). Phase 1 lands the user
// here and the panel names what it is waiting for; phase 2 replaces `RentSchedulePanel`'s body
// with RENT-001's generated periods, and neither this route, the navigation that reaches it nor
// the i18n keys it renders move.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { RentSchedulePanel } from '@/features/contracts/panels';
import { useContract } from '@/features/contracts/queries';

export const Route = createFileRoute('/app/contracts/$contractId/schedule')({
  component: ScheduleTabScreen,
});

function ScheduleTabScreen() {
  const { contractId } = Route.useParams();
  const contract = useContract(contractId);

  if (contract.isPending) return <LoadingState rows={2} />;
  if (contract.isError) return <ErrorState error={contract.error} onRetry={() => void contract.refetch()} />;

  return (
    <RentSchedulePanel
      contractId={contractId}
      status={contract.data.status}
      currency={contract.data.rentCurrency}
    />
  );
}
